import React, { useEffect, useRef, useState } from 'react';
import { 
    ListItem,
    ListItemButton,
    ListItemText,
    Tooltip,
    Typography
} from '@mui/material';

export default function ItemList(props) {
    const { active, title, label, onItemClick, iconButton, disabled, disabledReason } = props

    const [textOverflowStatus, setTextOverflowStatus] = useState(false);
    const textElementRef = useRef();

    const compareSize = () => {
        const compare = textElementRef.current.querySelector('.MuiListItemText-primary').scrollWidth > textElementRef.current.clientWidth;
        setTextOverflowStatus(compare);
      };

    useEffect(() => {
        compareSize();
        window.addEventListener('resize', compareSize);
      }, []);

    useEffect(() => () => {
        window.removeEventListener('resize', compareSize);
      }, []);
      


    return (
        <ListItem
            divider
            disableGutters
            sx={{ 
                px: 1,
                py: 0, 
                height: {xs: 60, md: 80}, 
                // backgroundColor: 'black',
                backgroundColor: active ? 'rgb(50,65,100)' : 'black',
                padding: 0,                
                '&:hover': {
                    backgroundColor: '#404040', // Change this to your desired hover color
                },
                transition: 'background-color 0.2s ease-out'
            }}
            secondaryAction={
                iconButton
            }
        >
            <Tooltip 
                title={title} 
                enterDelay={500} 
                disableHoverListener={!textOverflowStatus} 
                disableInteractive
            >
                <ListItemButton
                    key={label}
                    onClick={onItemClick}
                    sx={{
                        height: '100%', 
                        width: '100%',
                        paddingLeft: '30px',
                        paddingRight: '40px'
                    }}
                    disabled={disabled}                   
                >
                    <ListItemText
                        ref={textElementRef}
                        primary={title}
                        
                        primaryTypographyProps={{
                            maxWidth: '100%',
                            variant:"header6",
                            fontWeight:'bold',
                            color:"white",
                            noWrap: true,
                            
                            }}
                            secondary={label}
                            secondaryTypographyProps={{
                                variant:"body2",
                                color:"#abb2bf",
                            }}
                    />
                </ListItemButton>
            </Tooltip>
            <Typography 
                marginRight="20px" 
                color="rgb(159, 87, 23)"
                sx={{visibility: disabled ? "visible" : "hidden"}}
                variant="caption"
            >
                {disabledReason}
            </Typography>
        </ListItem>
    )
}